/**
 * Terms of Service page — content sourced from terms.md
 */

import type React from 'react';

import { MarkdownDocPage } from '../../components/MarkdownDoc/MarkdownDoc';
import termsMarkdown from '../../data/terms.md?raw';

export const Terms: React.FC = () => (
  <MarkdownDocPage
    markdown={termsMarkdown}
    pageTitle="Terms of Service"
    path="/terms"
  />
);
